module.exports = __webpack_public_path__ + "frontend/images/white/carousel/static/traveling.png?ced0ea11d3c8b4c5b689d19856f91659";